import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { includes, split, join, map, lowerCase } from "lodash";
import NavStickyWrapper from "./NavStickyWrapper";
import NavScrollContainer from "./NavScrollContainer";
import NavHomeLink from "./NavHomeLink";
import NavListStyleWrapper from "./NavListStyleWrapper";
import AlgoliaSearchInput from "./AlgoliaSearchInput";
import CategoryLabel from "./CategoryLabel";
import ArticleLabel from "./ArticleLabel";

const HelpNavContent = ({ currentCategory, currentTutorial, toc }) => {
  const data = useStaticQuery(graphql`
    query Helpery {
      allMarkdownRemark {
        edges {
          node {
            frontmatter {
              categories
              path
              title
              categories_weight
              hide_from_nav
            }
          }
        }
      }
    }
  `);
  const categories = [
    "Get started",
    "Navigate and organize content",
    "Connect your database",
    "Query and analyze data",
    "Create Reusable Datasets",
    "Visualize and present data",
    "Explore and share data",
    "Embedding",
    "Integrations",
    "Administration",
    "API",
    "FAQs", 
    "Contact us",
  ];
  const formatCategoryURL = category => {

    const splitString = split(category, " ");
    const output= `${join(map(splitString, str => str.toLowerCase()), "-")}/`;
    return output;
  };

  const arbitrarySort = nodeEdges => {
    const arbitaryArray = [];
    // go the nodeEdges, and if any of them have a category that is NOT included in the original targets
    // add that catogory
    nodeEdges.forEach(edge => {
      if (
        !includes(categories, edge.node.frontmatter.categories[0]) 
        && edge.node.frontmatter.categories[0] !== "The Mode Playbook"
        && edge.node.frontmatter.categories[0] !== "legal"
        && !edge.node.frontmatter.hide_from_nav
      ) {
        categories.push(edge.node.frontmatter.categories[0]);
      }
    });
    // go thru each target and, in order of targets array, push them into the arbitaryArray
    categories.forEach(targetName => {
      arbitaryArray.push(
        nodeEdges.filter(obj =>
          obj.node.frontmatter.categories.includes(targetName)
          && !obj.node.frontmatter.hide_from_nav
        )
      );
    });

    return arbitaryArray;
  };

  const sortedGalleryEdges = arbitrarySort(data.allMarkdownRemark.edges);
  return (
    <NavStickyWrapper>
      <NavListStyleWrapper>
        <NavHomeLink to="/">Mode Help</NavHomeLink>
        <AlgoliaSearchInput />
        <NavScrollContainer>
          {sortedGalleryEdges.map((group, index) => {
            const groupLinks =
              categories[index] === currentCategory
                ? group
                  .sort((a, b) => {
                    return (
                      a.node.frontmatter.categories_weight -
                      b.node.frontmatter.categories_weight
                    );
                  })
                  .map(({ node }) => {
                    return (
                      <div key={node.frontmatter.title}>
                        {currentTutorial === node.frontmatter.title ? (
                          <ArticleLabel key={node.frontmatter.title} isActive>
                            {node.frontmatter.title}
                          </ArticleLabel>
                        ) : (
                            <Link to={node.frontmatter.path}>
                              <ArticleLabel>
                                {node.frontmatter.title}
                              </ArticleLabel>
                            </Link>
                          )}
                        {currentTutorial === node.frontmatter.title && toc}
                      </div>
                    );
                  })
                : [];
            return (
              <ul key={categories[index]}>
                {categories[index] !== currentCategory ? (
                  <Link
                    to={`/${formatCategoryURL(categories[index])}`}
                  >
                    <li>
                      <CategoryLabel>{categories[index]}</CategoryLabel>
                    </li>
                  </Link>
                ) : (
                    <li key={categories[index]}>
                      {/* Only Highlight category label if on Category hub page, otherwise highlight current tutorial label */}
                      <CategoryLabel isActive={currentTutorial === ""}>
                        {categories[index]}
                      </CategoryLabel>
                      <ul>{groupLinks}</ul>
                    </li>
                  )}
              </ul>
            );
          })}
        </NavScrollContainer>
      </NavListStyleWrapper>
    </NavStickyWrapper>
  );
};

export default HelpNavContent;
